import { Record } from 'immutable';
const DEFAULT_HEADINGS_FONT = 'helvetica';
const DEFAULT_ARTICLE_BODY_FONT = 'georgia, palatino';
const DEFAULT_TOC_FONT = 'helvetica';
const DEFAULT_BREADCRUMBS_FONT = 'helvetica';
const ThemeSettingsRecord = Record({
  breadcrumbs_font: {
    font: DEFAULT_BREADCRUMBS_FONT
  },
  toc_font: {
    font: DEFAULT_TOC_FONT
  },
  article_body_font: {
    font: DEFAULT_ARTICLE_BODY_FONT
  },
  // @bend-expect trellis-skip-migration
  header_welcome_message_color: {
    color: '#2d3e50',
    opacity: 100
  },
  headings_font: {
    font: DEFAULT_HEADINGS_FONT
  },
  // @bend-expect trellis-skip-migration
  links_color: {
    color: '#2d3e50',
    opacity: 100
  },
  // @bend-expect trellis-skip-migration
  mobile_nav_menu_color: {
    color: '#ffffff',
    opacity: 100
  },
  // @bend-expect trellis-skip-migration
  nav_bar_link_color: {
    color: '#2d3e50',
    opacity: 100
  },
  social_icon_shape_and_color: 'circle_color',
  theme_type: 'tiles'
});
export default ThemeSettingsRecord;